<div class="cf-page">

  <!-- Loading -->
  <div class="cf-loading" *ngIf="!resumeloading">
    <div class="cf-loading__icon-wrap"><mat-icon>trending_up</mat-icon></div>
    <div class="cf-loading__dots"><span></span><span></span><span></span></div>
    <p class="cf-loading__text">Cargando flujo de caja…</p>
  </div>

  <!-- Content -->
  <ng-container *ngIf="resumeloading">
    <div class="cf-header">
      <div class="cf-header__left">
        <div class="cf-header__icon-wrap"><mat-icon>trending_up</mat-icon></div>
        <div>
          <h2 class="cf-header__title">Flujo de Caja</h2>
          <p class="cf-header__sub">Año {{ yearSelected }}</p>
        </div>
      </div>
      <mat-slide-toggle [(ngModel)]="showGlobal" (change)="getData()" class="cf-toggle">
        Todas las actividades
      </mat-slide-toggle>
    </div>

    <div class="cf-table-wrap">
      <table class="cf-table">
        <thead>
          <tr>
            <th class="cf-th cf-th--label">Concepto</th>
            <th class="cf-th">Año {{ yearSelected }}</th>
            <th class="cf-th">Enero</th>
            <th class="cf-th">Febrero</th>
            <th class="cf-th">Marzo</th>
            <th class="cf-th">Abril</th>
            <th class="cf-th">Mayo</th>
            <th class="cf-th">Junio</th>
            <th class="cf-th">Julio</th>
            <th class="cf-th">Agosto</th>
            <th class="cf-th">Septiembre</th>
            <th class="cf-th">Octubre</th>
            <th class="cf-th">Noviembre</th>
            <th class="cf-th">Diciembre</th>
          </tr>
        </thead>
        <tbody>
          <!-- ENTRADAS -->
          <tr class="cf-tr cf-tr--section">
            <td class="cf-td cf-td--section" colspan="14">ENTRADAS DE DINERO</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Aportación del empresario</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'employerContribution') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Deuda contraída / Préstamos</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'incurredDebtRequestedLoans') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Ventas e ingresos</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'salesAndRevenues') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Subvenciones</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'subsidies') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Intereses cuentas bancarias y otros</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'interestFromBankAccountsAndOthers') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr cf-tr--total">
            <td class="cf-td cf-td--total">TOTAL ENTRADAS</td>
            <td class="cf-td cf-td--total" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'totalIncome') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>

          <!-- SALIDAS -->
          <tr class="cf-tr cf-tr--section">
            <td class="cf-td cf-td--section" colspan="14">SALIDAS DE DINERO</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Adquisiciones de activo</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'assetAcquisitions') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Proveedores y acreedores (gastos)</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'suppliersAndCreditorsExpenses') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Devolución de préstamos / tarjetas</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'loanRepayment') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Pago de intereses</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'interestPayment') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Personal (nóminas y seg. social)</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'personnelSalaryAndSocialSecurityPayments') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr cf-tr--total">
            <td class="cf-td cf-td--total">TOTAL SALIDAS</td>
            <td class="cf-td cf-td--total" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'totalOutgoings') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>

          <!-- RESULTADOS -->
          <tr class="cf-tr cf-tr--section">
            <td class="cf-td cf-td--section" colspan="14">SALDOS Y RESULTADO</td>
          </tr>
          <tr class="cf-tr cf-tr--highlight">
            <td class="cf-td cf-td--label">Diferencia</td>
            <td class="cf-td cf-td--signed" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex"
                [class.cf-positive]="getValue(i,'difference') >= 0"
                [class.cf-negative]="getValue(i,'difference') < 0">
              {{ getValue(i, 'difference') | currency:'EUR':'symbol':'1.2-2':'es' }}
            </td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Saldo cuentas bancarias</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'bankAccountBalance') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Saldo cuentas efectivo</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'cashBalance') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr">
            <td class="cf-td cf-td--label">Saldo disponible ctas crédito</td>
            <td class="cf-td" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex">{{ getValue(i, 'availableBalanceCreditAccounts') | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
          </tr>
          <tr class="cf-tr cf-tr--result">
            <td class="cf-td cf-td--total">RESULTADO</td>
            <td class="cf-td cf-td--total cf-td--signed" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12]; trackBy: trackByIndex"
                [class.cf-positive]="getValue(i,'result') >= 0"
                [class.cf-negative]="getValue(i,'result') < 0">
              {{ getValue(i, 'result') | currency:'EUR':'symbol':'1.2-2':'es' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
